<template>
  <div class="advert-page">
    <header-menu curPage="advert"></header-menu>

    <!-- 顶部蓝色背景区域 -->
    <div class="hero-section">
      <div class="hero-content">
        <h1>全场景广告样式</h1>
        <p>适配各类APP，兼顾体验与变现</p>
        <button class="register-btn" @click="goToAdmin">立即注册</button>
      </div>
    </div>

    <div class="ad-types-section">
      <h2>多种广告形成</h2>
      <div class="ad-types-container">
        <div class="ad-types-left">
          <div class="ad-type-item" :class="{ active: selectedAdType === '开屏广告' }" @mouseenter="clickAdType('开屏广告', 1)">
            <div class="ad-type-icon">
              <img class="icon-label" src="../../public/icon/icon_splash_78@2x.png" alt="开屏广告图标" />
            </div>
            <div class="ad-type-info">
              <h3>开屏广告</h3>
              <p>应用启动触发，曝光黄金位置</p>
            </div>
          </div>

          <div class="ad-type-item" :class="{ active: selectedAdType === '插屏广告' }" @mouseenter="clickAdType('插屏广告', 2)">
            <div class="ad-type-icon">
              <img class="icon-label" src="../../public/icon/icon_interstitial_78@2x.png" alt="插屏广告图标" />
            </div>
            <div class="ad-type-info">
              <h3>插屏广告</h3>
              <p>弹出窗口展示广告，适配各类场景</p>
            </div>
          </div>

          <div class="ad-type-item" :class="{ active: selectedAdType === 'Banner广告' }" @mouseenter="clickAdType('Banner广告', 3)">
            <div class="ad-type-icon">
              <img class="icon-label" src="../../public/icon/icon_banner_78@2x.png" alt="Banner广告图标" />
            </div>
            <div class="ad-type-info">
              <h3>Banner广告</h3>
              <p>可以持续展示广告，支持轮播</p>
            </div>
          </div>

          <div class="ad-type-item" :class="{ active: selectedAdType === '原生广告' }" @mouseenter="clickAdType('原生广告', 4)">
            <div class="ad-type-icon">
              <img class="icon-label" src="../../public/icon/icon_native_78@2x.png" alt="原生广告图标" />
            </div>
            <div class="ad-type-info">
              <h3>原生广告</h3>
              <p>原生注入，与应用风格统一</p>
            </div>
          </div>
        </div>

        <!-- 中间手机图片 -->
        <div class="phone-display">
          <img :src="`../../public/page_${adImageNum}@2x.png`" alt="广告展示" />
        </div>

        <!-- 右侧广告类型 -->
        <div class="ad-types-right">
          <div class="ad-type-item" :class="{ active: selectedAdType === '全屏视频广告' }" @mouseenter="clickAdType('全屏视频广告', 5)">
            <div class="ad-type-info">
              <h3>全屏视频广告</h3>
              <p>视频全屏展示，获得更好收益</p>
            </div>
            <div class="ad-type-icon">
              <img class="icon-label" src="../../public/icon/icon_full_78@2x.png" alt="全屏视频广告图标" />
            </div>
          </div>

          <div class="ad-type-item" :class="{ active: selectedAdType === '激励视频广告' }" @mouseenter="clickAdType('激励视频广告', 6)">
            <div class="ad-type-info">
              <h3>激励视频广告</h3>
              <p>用户主动观看，更好的体验，更高的收益</p>
            </div>
            <div class="ad-type-icon">
              <img class="icon-label" src="../../public/icon/icon_motivation_78@2x.png" alt="激励视频广告图标" />
            </div>
          </div>

          <div class="ad-type-item" :class="{ active: selectedAdType === '原生通知广告' }" @mouseenter="clickAdType('原生通知广告', 7)">
            <div class="ad-type-info">
              <h3>原生通知广告</h3>
              <p>更美观更灵活，位置可居</p>
            </div>
            <div class="ad-type-icon">
              <img class="icon-label" src="../../public/icon/icon_notice_78@2x.png" alt="原生通知广告图标" />
            </div>
          </div>

          <div class="ad-type-item" style="opacity: 0;">
            <div class="ad-type-info">
              <h3>原生通知广告</h3>
              <p>更美观更灵活，位置可居</p>
            </div>
            <div class="ad-type-icon">
              <span class="icon-label">🔔</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-menu></footer-menu>
  </div>
</template>
<script>
import HeaderMenu from '../components/header-menu.vue';
import FooterMenu from '../components/footer-menu.vue';
export default {
  name: 'advert',
  components: {
    HeaderMenu,
    FooterMenu
  },
  data() {
    return {
      selectedAdType: '开屏广告',
      adImageNum: 1,
    }
  },
  methods: {
    // 可以在这里添加注册按钮的点击事件处理
    goToAdmin() {
      window.open('https://admin.kuaibian.top/register');
    },
    clickAdType(type, num) {
      this.selectedAdType = type;
      this.adImageNum = num;
    }
  }

}
</script>

<style scoped>
.advert-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 顶部蓝色背景区域 */
.hero-section {
  //background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  padding: 80px 0;
  height: 360px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('../../public/banner_2@2x.png');
  background-size: cover;
  background-position: center;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-content h1 {
  font-size: 38px;
  margin-bottom: 42px;
  font-weight: bold;
}

.hero-content p {
  font-size: 26px;
  margin-bottom: 52px;
  opacity: 0.9;
}

.register-btn {
  background: #10D294;
  color: white;
  border: none;
  padding: 14px 28px;
  font-size: 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.register-btn:hover {
  background-color: #45a049;
}

/* 多种广告形成区域 */
.ad-types-section {
  padding: 60px 0;
  text-align: center;
}

.ad-types-section h2 {
  font-size: 28px;
  margin-bottom: 40px;
  color: #333;
}

.ad-types-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  //gap: 40px;
  flex-wrap: wrap;
}

/* 左侧广告类型 */
.ad-types-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  margin-right: -65px;
  min-width: 380px;
}

/* 右侧广告类型 */
.ad-types-right {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  margin-left: -65px;
  min-width: 380px;
  z-index: 10;
}

/* 广告类型项 */
.ad-type-item {
  display: flex;
  align-items: center;
  background: rgba(16, 210, 148, 0.1);
  padding: 16px;
  border-radius: 65px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
}

.ad-type-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.ad-type-item.active {
  background: #10D294;
  color: white;
}

.ad-type-item.active .ad-type-info h3,
.ad-type-item.active .ad-type-info p {
  color: white;
}

.ad-type-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 40px;
  flex-shrink: 0;
}

.ad-types-right .ad-type-icon {
  margin-right: 0;
  margin-left: 36px;
}

.icon-label {
  width: 64px;
  height: 64px;
  padding-left: 30px;
}

.ad-types-right .icon-label {
  width: 64px;
  height: 64px;
  padding-right: 50px;
}

.ad-type-info {
  flex: 1;
  text-align: left;
  margin-top: -10px;
}

.ad-types-right .ad-type-info {
  text-align: right;
}

.ad-type-info h3 {
  font-size: 18px;
  margin-bottom: 4px;
  color: #333;
}

.ad-type-info p {
  font-size: 14px;
  color: #666;
}

/* 中间手机图片 */
.phone-display {
  width: 330px;
  flex-shrink: 0;
  position: relative;
  border-radius: 20px;
  background: #999;
  z-index: 999;
}

.phone-display img {
  width: 302px;
  height: auto;
  margin: 14px 0;
  border-radius: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .ad-types-container {
    flex-direction: column;
  }

  .ad-types-left,
  .ad-types-right {
    width: 100%;
    max-width: 400px;
  }

  .ad-type-item {
    flex-direction: column;
    text-align: center;
  }

  .ad-type-icon {
    margin-right: 0;
    margin-bottom: 12px;
  }

  .ad-types-right .ad-type-icon {
    margin-left: 0;
    margin-top: 12px;
  }

  .ad-type-info {
    text-align: center;
  }

  .ad-types-right .ad-type-info {
    text-align: center;
  }

  .phone-display img {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Advert.vue